import React, { useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const BRAND        = '#6eb446'
const BRAND_DARK   = '#2d5918'
const BRAND_SHADOW = '0 8px 24px rgba(110,180,70,0.35)'

const NoMatch: React.FC = () => {
  const { t }  = useTranslation()
  const navigate = useNavigate()

  useEffect(() => {
    document.body.classList.add('page-home')
    return () => document.body.classList.remove('page-home')
  }, [])

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f8faf6',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem 1.5rem',
      fontFamily: 'Nunito, sans-serif',
    }}>
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50%       { transform: translateY(-12px); }
        }
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(20px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .nm-btn-primary:hover  { filter: brightness(1.08); }
        .nm-btn-outline:hover  { background-color: #f4fbf0 !important; }
      `}</style>

      {/* Logo */}
      <div style={{ marginBottom: '2.5rem', animation: 'fadeUp 0.5s ease both' }}>
        <Link to="/">
          <img
            src="https://labeldictate.com/assets/img/Label-Dictate-Logo-V2021.png"
            width={64}
            alt="Label Dictate"
          />
        </Link>
      </div>

      {/* 404 number */}
      <div style={{
        animation: 'float 4s ease-in-out infinite',
        marginBottom: '1rem',
        lineHeight: 1,
        userSelect: 'none',
      }}>
        <span style={{
          fontSize: 'clamp(7rem, 22vw, 12rem)',
          fontWeight: 900,
          letterSpacing: '-0.05em',
          background: `linear-gradient(135deg, ${BRAND} 0%, ${BRAND_DARK} 100%)`,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
        }}>
          404
        </span>
      </div>

      {/* Card */}
      <div style={{
        width: '100%',
        maxWidth: 460,
        backgroundColor: '#fff',
        borderRadius: 24,
        boxShadow: '0 8px 40px rgba(0,0,0,0.08)',
        border: '1px solid #f1f5f9',
        overflow: 'hidden',
        animation: 'fadeUp 0.6s ease 0.1s both',
      }}>
        <div style={{ height: 4, background: `linear-gradient(90deg, ${BRAND_DARK}, ${BRAND})` }} />
        <div style={{ padding: '2rem 2rem 2.25rem', textAlign: 'center' }}>

          <h1 style={{
            margin: '0 0 0.6rem',
            fontSize: '1.4rem',
            fontWeight: 800,
            color: '#1e293b',
            letterSpacing: '-0.01em',
          }}>
            {t('no_match.not_found') || 'Página no encontrada'}
          </h1>

          <p style={{ margin: '0 0 0.4rem', fontSize: '0.9rem', color: '#64748b', lineHeight: 1.7 }}>
            {t('no_match.p1') || 'La página que buscas no existe o fue movida.'}
          </p>
          <p style={{ margin: '0 0 2rem', fontSize: '0.85rem', color: '#94a3b8' }}>
            {t('no_match.p2') || 'Verifica la URL o regresa al inicio.'}
          </p>

          {/* Actions */}
          <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            

            <Link
              to="/"
              className="nm-btn-primary"
              style={{
                padding: '10px 24px',
                borderRadius: 9999,
                border: 'none',
                backgroundColor: BRAND,
                color: '#fff',
                fontWeight: 700,
                fontSize: '0.88rem',
                textDecoration: 'none',
                boxShadow: BRAND_SHADOW,
                transition: 'filter 0.15s',
              }}
            >
              ←  {t('no_match.back') || 'Regresar'}
            </Link>
          </div>

        </div>
      </div>

      {/* Footer note */}
      <p style={{
        marginTop: '2.5rem',
        fontSize: '0.75rem',
        color: '#cbd5e1',
        animation: 'fadeUp 0.6s ease 0.2s both',
      }}>
        Label Dictate © {new Date().getFullYear()}
      </p>
    </div>
  )
}

export default NoMatch
